<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" v-on:click.stop="" style="height:100vh;overflow:scroll;padding-bottom:80px;">
                    <h2 class="fs18 mb8" style="text-align:left;">{{ params.title }}</h2>
                    <div class="modal-body radius8 mt8p mb8p" style="text-align:left;">
                        <slot name="body">
                            <p class="fs14">・お支払いはクレジットカードのみとなります。</p>
                            <p class="fs14">・ご請求時期は各カード会社により異なります。</p>
                            <p class="fs14">・メンテナンスパック 数量１</p>
                            <p class="fs14">・本サービスは毎月自動更新のサブスクリプションであり、お客様が各月の末日の前日までに解約の手続きをしない限り、本サービスが継続します。</p>
                            <p class="fs14">・本サービスの解約については、本アプリ上でいつでも翌月分以降の解約が可能です。</p>
                            <p class="fs14">・本サービス利用料は月額500円であり、毎月月末に翌月分のサービス利用料が自動決済されます。初回決済は入会時に決済されます。</p>
                            <p class="fs14">・仮にお客様が1年間本サービスを利用された場合、年間の支払金額は6,000円となります。</p>
                            <p class="fs14">・洗車プリペイド500ポイントは毎月1日の午前4時に【コスモの公式】アプリに付与します。初回付与は初回決済後即時付与します。</p>
                            <p class="fs14">・洗車プリペイドポイントの有効期限はチャージされた日から180日です。</p>
                            <p class="fs14">・給油割引の1リットル1円引き、上限100Lは毎月1日に付与します。初回付与は初回決済の翌日付与します。燃料割引の有効期限は毎月月末までとなります。</p>
                            <p class="fs14">・車検6か月後点検はサービス開始月（初回決済月）から6か月目、18か月点検はサービス開始月（初回決済月）から18か月目にサービスを提供します。</p>
                            <p class="fs14">・車検実施から12か月後の法定12か月点検はサービス開始月（初回決済月）から12か月目にサービスを提供します。</p>
                            <p class="fs14">・オイル交換は毎回の点検時に提供します。</p>
                            <p class="fs14">・申し込み可能期間はお客様の車両の車検満了日前後1か月間となります。<br>（例）車検満了日が8月15日の場合、申し込み可能期間は7月15日～9月15日となります。</p>
                            <p class="fs14">・商品の性質上、お申し込み後のキャンセル並びにサービス利用料の返金、サービスの返品は出来ません。</p>
                            <p class="fs14">・本サービスのご利用店舗は入会された店舗に限ります。</p>
                            <p class="fs14"><br></p>
                            <p class="fs14">【サービス提供元】</p>
                            <p class="fs14">コスモ石油マーケティング株式会社</p>
                            <p class="fs14">東京都中央区京橋１－７－１</p>
                            <p class="fs14">代表者：髙山 直樹</p>
                            <p class="fs14">【連絡先】</p>
                            <p class="fs14">０１２０ー５３０３７２</p>
                            <p class="fs14">２４時間年中無休</p>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button type="button" class="button fs16 w100p mt16 mb0 pd16 radius200" @click="closeModal()">{{ params.buttonMessage }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import modal from '@/assets/v3/modal'

export default {
  props: ['params'],
  methods: {
    closeModal () {
      modal.close()
    }
  }
}
</script>
